import {ResponsiveContent} from "../../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {Button, Figure, ListGroup, Stack} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useLocalFilter2, useMedia, useLongPress, useMediaCount, useMediaList, useMediaOrderOptions, useSelect, useTouch} from "../../../../hooks";
import {useAlert, useAuth, useDarkMode} from "../../../../context";
import {ItemLoading} from "../../../_components";
import {OurPagination2} from "../../../_components";
import {OurClearAlert} from "../../../_components";
import {config} from "../../../../utils2";
import {MenuAdd, MenuBar, MenuClearSelectButton, MenuConfirmDeleteButton, MenuOrderBy, MenuSearchTerm, PageTitle} from "../../../_components";
import {isoTimestampToReadableDate} from "../utilities/readableDate";


export function Medias() {
    return <ResponsiveContent body={<MediaForm/>}/>
}

function MediaForm() {
    const {userId} = useAuth()
    const {success} = useAlert()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useMediaOrderOptions()

    // API Actions
    const {deleteItem, errorValue, clearErrorValue} = useMedia(userId)

    // API count all items
    const {count, setCount, loadingCount, errorCount, clearErrorCount} = useMediaCount()

    // API items per page
    const {list, setList, loadingList, errorList, clearErrorList} = useMediaList()

    // Filter
    const filteredList = useLocalFilter2(list, ["description"])

    // Select
    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(list)

    function handleOnItemsDelete() {
        selList
            .forEach(item =>
                deleteItem(item.id)
                    .then(() => {
                        setCount(count => count - 1)
                        setList(prev => prev.filter(obj => obj.id !== item.id))
                        success(`${item.description} has been deleted!`)
                    })
                    .catch(err => console.warn(err.message))
            )
        clearSelectItems()
    }

    return <Stack>
        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

        <PageTitle title="Medias">Manage medias.</PageTitle>

        <MenuBar>
            <MenuAdd to="/backend/media/add" icon="plus">Add</MenuAdd>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                {selList.length} {selList.length === 1 ? "row" : "rows"}
            </MenuClearSelectButton>
            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                <span>{selList.length} {selList.length === 1 ? "media" : "medias"}</span>
            </MenuConfirmDeleteButton>
        </MenuBar>

        <ItemLoading show={loadingCount || loadingList}/>

        {list && list.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id} item={item} selected={isItemSelected(item.id)} selectedCount={selList.length} onSelect={toggleSelectItems}
                                to={`/backend/media/${item.id}`}/>
                )}
            </ListGroup>
            :
            <span className="text-center">No media added yet</span>
        }

        <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>
    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {

    const [showFig, setShowFig] = useState(false)

    const touch = useTouch()
    const [show, setShow] = useState(false)

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    const {darkMode} = useDarkMode()
    const media_src = config.get_public_media(item.path, "thumb", darkMode)

    return (
        // <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "bg-light"} ${show && "bg-light-subtle"}`}
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    {showFig ?
                        <div className="mt-0 mb-0 d-flex justify-content-center align-items-center" style={{height: '120px', width: '120px'}}>
                            <i className="bi bi-ban" style={{fontSize: '70px'}}></i>
                        </div>
                        :
                        <Figure className="mt-2 mb-0 ms-1">
                            <Figure.Image
                                src={media_src}
                                alt={item.description}
                                rounded
                                height="120px"
                                width="120px"
                                loading="lazy"
                                onError={() => setShowFig(true)}
                            />
                        </Figure>
                    }
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.description}</span>
                        </Link>
                    </Stack>
                    <div className="text-nowrap fw-normal text-secondary small"><i className="bi bi-plus-lg me-1"/>{isoTimestampToReadableDate(item.created_at)}</div>
                    {item.updated_at &&
                        <div className="text-nowrap fw-normal text-secondary small"><i className="bi bi-arrow-repeat me-1"/>{isoTimestampToReadableDate(item.updated_at)}
                        </div>}
                </div>
                <div className="ms-auto">
                    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>
                        <span className="text-nowrap fw-normal text-secondary">Tags: {item.tags.length}</span>
                        <span className="text-nowrap fw-normal text-secondary">Products: {item.products.length}</span>
                    </Stack>
                </div>
            </Stack>

            <div className="ms-auto">
                {(!touch || selected || selectedCount > 0) &&
                    <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                        <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                    </Button>
                }
            </div>
        </Stack>

    )
}

